import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import { registerField, registerWidget } from "common/form/register";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import IOption from "common/models/IOption";
import { IQuickLink, QuickLinksField } from "./form/QuickLinksField";

export enum ListTypeOptions {
	NONE = "none",
	ROWS = "rows",
	CAROUSEL = "carousel"
}

export enum ItemTypeOptions {
	DEFAULT = "default", // "card"
	BUTTON = "button"
}

const itemTypeOptions: IOption[] = [
	{ value: ItemTypeOptions.DEFAULT, label: "Default (Cards)" },
	{ value: ItemTypeOptions.BUTTON, label: "Buttons" }
];

const listTypeOptions: IOption[] = [
	{ value: ListTypeOptions.NONE, label: "List" },
	{ value: ListTypeOptions.ROWS, label: "Responsive Rows" },
	{ value: ListTypeOptions.CAROUSEL, label: "Carousel" }
];

const linksInput = registerField(QuickLinksField, "any");
const listTypeInput = registerWidget(ButtonSelect.withOptions(listTypeOptions), "string");
const itemTypeInput = registerWidget(ButtonSelect.withOptions(itemTypeOptions), "string");

@Form({title: "Quick Links Panel Config"})
export class QuickLinksPanelConfig {

	@Input({type: listTypeInput, title: "View Type"})
	public view: ListTypeOptions;

	@Input({type: itemTypeInput, title: "Item Display"})
	public itemType?: ItemTypeOptions;

	@Input({type: InputType.CHECKBOX, title: "Show Thumbnails"})
	public showThumbnails: boolean;

	@Input({type: InputType.UNIT, title: "Thumbnail Height"})
	public thumbnailHeight: string = "100px";

	@Input({type: linksInput, title: "Items"})
	public content ?: IQuickLink[];

}



// WEBPACK FOOTER //
// ./src/panels/quickLinks/QuickLinksConfig.ts